// extracted by mini-css-extract-plugin
module.exports = {"slide":"index_slide_3XQ0d","slide-reverse":"index_slide-reverse_2xELE","pageContent":"index_pageContent_2ogZN","block":"index_block_1UhRH"};